import React, { useEffect, useState } from "react";
import { Card, Spin, Tag, Button, message } from "antd";
import { useParams } from "react-router-dom"; 
import { applyJobApi, getJobsApi } from "../../../apiservice/ats";
import { useNavigate } from "react-router-dom";

const PublicJobView = ({ candidateId }) => {
  const navigate = useNavigate();  
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [applying, setApplying] = useState(false);

  // Load job data
  useEffect(() => {
    const loadJob = async () => {
      try {
        setLoading(true);
        const res = await getJobsApi({ id });
        if (!res.data) {
          message.error("Job not found");
          setLoading(false);
          return;
        }
        setJob(Array.isArray(res.data) ? res.data[0] : res.data);
        setLoading(false);
      } catch (err) {
        console.error(err);
        message.error("Failed to load job");
        setLoading(false);
      }
    };
    loadJob();
  }, [id]);

  const handleApply = () => {
  navigate(`/jobs/${job.id}/apply`);
};

  if (loading) return <Spin size="large" style={{ display: "block", margin: 40 }} />;
  if (!job) return <div>Job not found</div>;

  return (
    <Card title={job.title} style={{ maxWidth: 600, margin: "40px auto" }}>
      <p><strong>Client:</strong> {job.client || "-"}</p>
      <p><strong>Location:</strong> {job.location || "-"}</p>
      <p><strong>Type:</strong> {job.job_type || "-"}</p>
      <p>
        <strong>Status:</strong>{" "}
        {job.status === "active" ? <Tag color="green">Open</Tag> : <Tag color="red">Closed</Tag>}
      </p>
      <p><strong>Description:</strong> {job.description || "-"}</p>

      {job.status === "active"&& (
            <Button
              type="primary" 
              loading={applying}
              onClick={handleApply}
              style={{
                backgroundColor: "#1890ff", // Ant Design primary blue
                borderColor: "#1890ff",
                color: "#fff",             // font color white
                fontWeight: "bold",
              }}
            >
              Apply Now
            </Button> 
      )}
    </Card>
  );
};

export default PublicJobView;
